import {FieldSpecialType, FieldType, IField, IFieldSettings, RealFieldType} from '@core/api/data-access';

export function getFieldType(realType: RealFieldType, init: Partial<IField>): FieldType {
	const jsonSettings: IFieldSettings = JSON.parse(init.settings);
	if (!jsonSettings) return undefined;
	const spacialType: FieldSpecialType = jsonSettings.SpecialType;
	const visible = init.visible;

	switch (realType) {
		case RealFieldType.Signature:
			return FieldType.signature;
		case RealFieldType.Checkbox:
			return FieldType.checkBox;
		case RealFieldType.Pushbutton:
			return FieldType.image;
		case RealFieldType.Text:
			switch (spacialType) {
				case FieldSpecialType.Date:
					return FieldType.dateField;
				case FieldSpecialType.GPS:
					return FieldType.GPS;
				case FieldSpecialType.Attachment:
					return FieldType.attachment;
				default:
					if (!visible) return FieldType.metadata;
					return FieldType.textBox;
			}
	}

	// switch (realType) {
	// 	case RealFieldType.Signature:
	// 		return FieldType.signature;
	// 	case RealFieldType.Checkbox:
	// 		return FieldType.checkBox;
	// 	case RealFieldType.Pushbutton:
	// 		return FieldType.image;
	// 	case RealFieldType.Text:
	// 		switch (spacialType) {
	// 			case FieldSpecialType.Date:
	// 				return FieldType.dateField;
	// 			case FieldSpecialType.GPS:
	// 				return FieldType.GPS;
	// 			case FieldSpecialType.Attachment:
	// 				return FieldType.attachment;
	// 			default:
	// 				if (!visible) return FieldType.metadata;
	// 				return FieldType.textBox;
	// 		}
	// }
	// return undefined;
}

export function getRealFieldType(type: FieldType): {realType: RealFieldType; spacialType: FieldSpecialType} {
	switch (type) {
		case FieldType.signature:
			return {realType: RealFieldType.Signature, spacialType: FieldSpecialType.None};
		case FieldType.checkBox:
			return {realType: RealFieldType.Checkbox, spacialType: FieldSpecialType.None};
		case FieldType.image:
			return {realType: RealFieldType.Pushbutton, spacialType: FieldSpecialType.None};
		case FieldType.dateField:
			return {realType: RealFieldType.Text, spacialType: FieldSpecialType.Date};
		case FieldType.GPS:
			return {realType: RealFieldType.Text, spacialType: FieldSpecialType.GPS};
		case FieldType.attachment:
			return {realType: RealFieldType.Text, spacialType: FieldSpecialType.Attachment};
		case FieldType.textBox:
			return {realType: RealFieldType.Text, spacialType: FieldSpecialType.None};
		case FieldType.metadata:
			return {realType: RealFieldType.Text, spacialType: FieldSpecialType.None};
	}
	return {realType: RealFieldType.Text, spacialType: FieldSpecialType.None};
}
